import { type AppNode } from '../../types';
import { type ImageNodeSource, type ImageNodesLayout } from './canvasAssetDropTypes';

/**
 * Builds AppNode[] for image nodes from normalized sources and layout.
 * Used by CanvasDropTarget (row layout at drop point) and selection bar (row layout).
 */
export function buildImageNodes(
  sources: ImageNodeSource[],
  layout: ImageNodesLayout,
): { nodes: AppNode[]; nextOffsetX: number } {
  const nodes: AppNode[] = [];
  let offsetX = 0;

  for (const source of sources) {
    const { width, height, fileName, assetId, versionId } = source;
    const position =
      layout.kind === 'row'
        ? { x: layout.startX + offsetX, y: layout.startY }
        : {
            x: layout.centerX - width / 2 + offsetX,
            y: layout.centerY - height / 2,
          };

    offsetX += width + layout.spacing;

    nodes.push({
      data: {
        assetId,
        fileName,
        media: source.media,
        source: 'workspace',
        type: 'image',
        versionId,
      },
      id: crypto.randomUUID(),
      position,
      style: { height, width },
      type: 'image',
    });
  }

  return { nextOffsetX: offsetX, nodes };
}
